@if (initialized) {
  <div class="card stickyCard">
    <div class="card-header-white header-underline">
      @if (tempRoute.defaultRoute) {
        <ng-container class="white-header-text">
          <h6 class="white-header-text">{{tempRoute.locationName}} ({{'DEFAULT_ROUTE' |translate}})</h6>
        </ng-container>
      }
      @if (!tempRoute.defaultRoute && !newRoute) {
        <h6 class="white-header-text"> {{tempRoute.name}} ({{tempRoute.id}})</h6>
      }
      @if (newRoute) {
        <h6 class="white-header-text">{{'CREATE_NEW_ROUTE' |translate}}</h6>
      }
      <span class="float-right cursorPointer" (click)="closeForm()">
        <span class="fa-light fa-xmark white-header-xmark-icon"></span>
      </span>
    </div>
    <div class="card-body-white">
      <div class="col-12">
        <mat-horizontal-stepper
          class="stepperContainer"
          #stepper
          [linear]="!informationStep?.completed && newRoute"
          [selectedIndex]="startTab"
          (selectionChange)="onStepChange($event)"
          >
          <ng-template matStepperIcon="edit">
            <mat-icon>done</mat-icon>
          </ng-template>
          <mat-step [stepControl]="informationForm" #informationStep>
            <ng-template matStepLabel>{{'BASIC_INFORMATION' | translate}}</ng-template>
            <!-- Use the stepId element to identify which step will rendered on select -->
            <div #stepId id="basic-info"></div>
            @if (selectedStep === 'basic-info') {
              <alarm-route-basic-information
                [tempRoute]="tempRoute"
                [alarmRouteLocations]="alarmRouteLocations"
                [callCenters]="callCenters"
                (onLocationChange)="onLocationChange()">
              </alarm-route-basic-information>
            }
          </mat-step>
          @if (!tempRoute.defaultRoute) {
            <mat-step>
              <ng-template matStepLabel>{{'DEVICES' |translate}}</ng-template>
              <div #stepId id="devices"></div>
              @if (selectedStep === 'devices') {
                <alarm-route-devices
                  [tempRoute]="tempRoute"
                  [deviceList]="rawDeviceList">
                </alarm-route-devices>
              }
            </mat-step>
          }
          <mat-step>
            <ng-template matStepLabel>{{'RECIPIENTS' |translate}}</ng-template>
            <div #stepId id="recipients"></div>
            @if (selectedStep === 'recipients') {
              <alarm-route-recipients
                [tempRoute]="tempRoute"
                [fallbackRecipients]="false"
                [allStaff]="allStaff"
                [allReceiverTeams]="allReceiverTeams"
                [customerInformation]="customerInformation">
              </alarm-route-recipients>
            }
          </mat-step>
          @if (!tempRoute.defaultRoute) {
            <mat-step>
              <ng-template matStepLabel>{{'SCHEDULE' |translate}}</ng-template>
              <div #stepId id="schedule"></div>
              @if (selectedStep === 'schedule') {
                <alarm-route-schedules [tempRoute]="tempRoute"></alarm-route-schedules>
              }
            </mat-step>
          }
          @if (tempRoute.fallBackType !== 'NONE' && !tempRoute.defaultRoute) {
            <mat-step>
              <ng-template matStepLabel>{{'FALLBACK_RECIPIENTS' |translate}}</ng-template>
              <div #stepId id="fallback-recipients"></div>
              @if (selectedStep === 'fallback-recipients') {
                <alarm-route-fallback-recipients
                  [tempRoute]="tempRoute"
                  [allStaff]="allStaff"
                  [allReceiverTeams]="allReceiverTeams"
                  [customerInformation]="customerInformation">
                </alarm-route-fallback-recipients>
              }
            </mat-step>
          }
          @if (tempRoute.alarmIndicationGroupEnabled) {
            <mat-step>
              <ng-template matStepLabel>{{'ALARM_INDICATION_GROUP' |translate}}</ng-template>
              <div #stepId id="alarm-indication-group"></div>
              @if (selectedStep === 'alarm-indication-group') {
                <app-alarm-route-alarm-indication-groups
                  [tempRoute]="tempRoute"
                  [deviceList]="rawDeviceList">
                </app-alarm-route-alarm-indication-groups>
              }
            </mat-step>
          }
        </mat-horizontal-stepper>
      </div>
      <div class="d-none d-sm-block button-container">
        <button [disabled]="!tempRoute.name" class="btn btn-outline-primary gray-bg mr-2"
          (click)="validateRoute(false);"><span class="fa-light fa-floppy-disk"></span> {{'SAVE'
        |translate}}</button>
        <button class="btn btn-outline-danger" (click)="this.closeForm()"><span class="fal fa-times"></span>
      {{'CANCEL' |translate}}</button>
      <button [disabled]="!tempRoute.name || stepper?.selectedIndex + 1 === stepper?.steps?.length"
      class="btn btn-outline-primary gray-bg float-right" (click)="stepper.next()">{{'NEXT' |translate}}</button>
      <button [disabled]="stepper?.selectedIndex === 0" class="btn btn-outline-primary gray-bg float-right mr-2"
      (click)="stepper.previous()">{{'PREVIOUS' |translate}}</button>
    </div>
    <div class="d-block d-sm-none button-container">
      <button [disabled]="!tempRoute.name" class="btn btn-outline-primary gray-bg mr-2"
        (click)="validateRoute(false);"><span class="fa-light fa-floppy-disk"></span></button>
        <button class="btn btn-outline-danger" (click)="this.closeForm()"><span
        class="fa-light fa-xmark"></span></button>
        <button [disabled]="!tempRoute.name || stepper?.selectedIndex + 1 === stepper?.steps?.length"
          class="btn btn-outline-primary gray-bg float-right" (click)="stepper.next()"><span
        class="fa-light fa-arrow-right"></span></button>
        <button [disabled]="stepper?.selectedIndex === 0" class="btn btn-outline-primary gray-bg float-right mr-2"
          (click)="stepper.previous()"><span class="fa-light fa-arrow-left"></span></button>
        </div>
      </div>
    </div>
  }


  @if (!initialized) {
    <div class="row">
      <div class="col-lg-12">
        <img class="fadeLoader centerLoader logoSmall" src="assets/img/loading_logo.svg">
      </div>
    </div>
  }
